import { gql } from 'graphql-request'

export const completeOnboardingStepMutation = gql`
  mutation CompleteOnboardingStep(
    $corporateId: ID!
    $stepKey: OnboardingStepKey!
    $completedByUserId: ID
  ) {
    completeOnboardingStep(
      corporateId: $corporateId
      stepKey: $stepKey
      completedByUserId: $completedByUserId
    )
  }
`

export const skipOnboardingStepMutation = gql`
  mutation SkipOnboardingStep($corporateId: ID!, $stepKey: OnboardingStepKey!) {
    skipOnboardingStep(corporateId: $corporateId, stepKey: $stepKey)
  }
`

export const requestUpgradeMutation = gql`
  mutation RequestUpgrade($corporateId: ID!, $requestedByName: String, $requestedByEmail: String) {
    requestUpgrade(
      corporateId: $corporateId
      requestedByName: $requestedByName
      requestedByEmail: $requestedByEmail
    )
  }
`

export const createMemberPreviewSessionMutation = gql`
  mutation CreateMemberPreviewSession($corporateId: ID!) {
    createMemberPreviewSession(corporateId: $corporateId) {
      memberToken
      kioskToken
      previewMemberId
      previewKioskUserId
    }
  }
`

export const createCheckoutSessionMutation = gql`
  mutation CreateCheckoutSession(
    $corporateId: ID!
    $planId: String!
    $successUrl: String!
    $cancelUrl: String!
  ) {
    createCheckoutSession(
      corporateId: $corporateId
      planId: $planId
      successUrl: $successUrl
      cancelUrl: $cancelUrl
    ) {
      checkoutUrl
    }
  }
`
